(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-cart-cross-sell-slider-script]");
  const styles = [
    loader?.dataset.cartCrossSellSwiperStyle,
    loader?.dataset.cartCrossSellVideoStyle,
    loader?.dataset.cartCrossSellImageStyle,
  ].filter(Boolean);
  const sliderScript = loader?.dataset.cartCrossSellSliderScript;
  let readyPromise;

  const loadStyle = (href) =>
    new Promise((resolve, reject) => {
      const existing = Array.from(
        document.querySelectorAll('link[rel="stylesheet"]'),
      ).find((link) => link.href === href);

      if (existing) {
        resolve();
        return;
      }

      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = href;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    });

  const loadSlider = () =>
    new Promise((resolve, reject) => {
      if (!sliderScript || customElements.get("slideshow-section")) {
        resolve();
        return;
      }

      const existing = Array.from(document.scripts).find(
        (script) => script.src === sliderScript,
      );
      if (existing) {
        customElements.whenDefined("slideshow-section").then(resolve, reject);
        return;
      }

      const script = document.createElement("script");
      script.type = "module";
      script.src = sliderScript;
      script.addEventListener(
        "load",
        () => customElements.whenDefined("slideshow-section").then(resolve, reject),
        { once: true },
      );
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });

  const load = () => {
    const crossSell = document.querySelector(".wt-cart__cross-sell");
    if (!crossSell) return Promise.resolve();
    if (readyPromise) return readyPromise;

    readyPromise = Promise.all(styles.map(loadStyle))
      .then(() => {
        if (crossSell.querySelector("slideshow-section")) return loadSlider();
      })
      .catch((error) => {
        readyPromise = null;
        throw error;
      });

    return readyPromise;
  };

  document.addEventListener("cart-drawer-open", () => {
    load().catch(() => undefined);
  });
})();
